/** @format */

export const CONTENT_CATEGORY_ARTICLE_RESULTS_PER_PAGE = 12;

export const AUTHOR_ARTICLE_RESULTS_PER_PAGE = 3;

export const AUTHOR_CAROUSEL_RESULTS_PER_PAGE = 50;

export const FEATURED_ARTICLES_COUNT = 3;
